import React from "react";
import Link from "next/link";
import { getFavoriteCompanyPath, getMyPageInfoPath } from "common";

import registeredEventsSrc from "../../../assets/images/accent_book.svg";
import favoriteCompaniesSrc from "../../../assets/images/accent_building.svg";
import personalInfoSrc from "../../../assets/images/accent_personal_info.svg";
import backgroundImage from "../../../assets/images/hero.jpg";
import styles from "./MyPageHero.module.scss";
import { ContentCard } from "./ContentCard";
import { Routes } from "../../generated/routes";

interface Props {
  name: string | null;
}

class MyPageHero extends React.PureComponent<Props> {
  public render() {
    const { name } = this.props;

    return (
      <div>
        <div
          className={styles.image}
          style={{
            backgroundImage: `url(${backgroundImage})`,
          }}
        >
          <div className={styles.main}>
            <p className={styles.welcome}>ようこそ、</p>
            {name && <span className={styles.userName}>{name} 様</span>}
          </div>
        </div>
        <div className={styles.main}>
          <div className={styles.cardsContainer}>
            <Link href={getMyPageInfoPath()}>
              <a className={styles.card}>
                <ContentCard
                  title="プロフィール"
                  titleEn="Profile"
                  iconSrc={personalInfoSrc}
                />
              </a>
            </Link>
            <Link href={Routes.url("/mypage/events", {})}>
              <a className={styles.card}>
                <ContentCard
                  title="申し込みイベント"
                  titleEn="Registered Events"
                  iconSrc={registeredEventsSrc}
                />
              </a>
            </Link>
            <Link href={getFavoriteCompanyPath()}>
              <a className={styles.card}>
                <ContentCard
                  title="お気に入り企業"
                  titleEn="Favorite Companies"
                  iconSrc={favoriteCompaniesSrc}
                />
              </a>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export { MyPageHero };
